module.exports = __webpack_public_path__ + "static/media/excellent.a86df08d.png";